const LOCALIZED_ATTR = 'data-mirage-camera-prompt-localized';

const CAMERA_PERMISSION_PROMPT_RU =
    'Нажмите «Разрешить», чтобы увидеть картину 📷';
const CAMERA_PERMISSION_PROMPT_EN =
    'Tap «Allow» to view painting 📷';

const isRussianLocale = (): boolean => {
    const languages =
        navigator.languages?.length > 0
            ? navigator.languages
            : [navigator.language];
    return languages.some((lang) => lang.toLowerCase().startsWith('ru'));
};

export const getCameraPermissionPromptText = (): string =>
    isRussianLocale()
        ? CAMERA_PERMISSION_PROMPT_RU
        : CAMERA_PERMISSION_PROMPT_EN;

export const applyCameraPermissionPromptText = (): void => {
    const el = document.getElementById('requestingCameraPermissions');
    if (!el || el.hasAttribute(LOCALIZED_ATTR)) return;

    const text = getCameraPermissionPromptText();
    const icon = el.querySelector('#requestingCameraIcon');
    el.replaceChildren(...(icon ? [icon] : []), document.createTextNode(text));
    el.setAttribute(LOCALIZED_ATTR, '');
};

export const observeCameraPermissionPrompt = (): void => {
    applyCameraPermissionPromptText();

    const observer = new MutationObserver(() => {
        applyCameraPermissionPromptText();
    });

    observer.observe(document.body, { childList: true, subtree: true });
};
